import {
  disputeReason,
  disputeSource,
  disputeStatus,
  disputeType,
} from "@redotech/redo-model/disputes/dispute-definition";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const reclaimDisputeRowSchema_ = z.object({
  id: z.coerce.string(),
  accountId: z.coerce.string(),
  source: z.enum(disputeSource),
  sourceDisputeId: z.string(),
  sourceOrderId: z.string().nullish(),
  type: z.enum(disputeType),
  status: z.enum(disputeStatus),
  reason: z.enum(disputeReason).nullish(),
  networkReasonCode: z.string().nullish(),
  amount: z.coerce.number(),
  currency: z.string(),
  evidenceDueBy: z.coerce.date().nullish(),
  evidenceSentOn: z.coerce.date().nullish(),
  finalizedOn: z.coerce.date().nullish(),
  initiatedAt: z.coerce.date(),
  rawDispute: z.unknown(),
  aiEvidenceGeneratedAt: z.coerce.date().nullish(),
  autoEvidenceDisabled: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullish(),
  teamName: z.string().nullish(),
  hasEvidence: z.boolean(),
});

export const reclaimDisputeRowSchema: z.ZodType<ReclaimDisputeRow> =
  reclaimDisputeRowSchema_;
export interface ReclaimDisputeRow
  extends z.infer<typeof reclaimDisputeRowSchema_> {}

export const getReclaimDisputes = unaryRpc({
  name: "getReclaimDisputes" as const,
  input: z.object({
    offset: z.number().int().min(0).optional(),
    limit: z.number().int().min(1).max(1000).optional(),
  }),
  output: z.object({
    disputes: z.array(reclaimDisputeRowSchema_),
    total: z.number().int(),
  }),
});
